<template>
  <div class="project-detail width-full flex flex-column" :class="isIE?'height-full':''" style="minHeight: 100%">
    <div class="project-head">
      <div class="margin flex">
        <div class="go-list">
          <router-link :to="path === '/workbench/index' ? '/project/joined/list' : path" tag="div">
            <i class="r2-icon-hardware_keyboard_backspace_outlined cursor-pointer hover-link"></i>
          </router-link>
        </div>
        <div class="content-msg">
          <w-row type="flex" justify="space-between">
            <w-col class="flex-1 border-box relative" style="padding-right: 40px;">
              <div class="name absolute width-full">
                <span class="ellipsis inline-block" :style="{maxWidth: `calc(100% - ${isRecord ? 42 : 162}px)`}">{{prjStatus.prjName}}</span>
                <i v-if="prjStatus.prjCategory === 1 && !isRecord" class="pricing-collaboration"></i>
                <!--<w-button type="minor" @click="enterClick" style="padding:0; height: 0px; border:0;"></w-button>-->
                <w-button type="minor" v-if="(isAdmin||prjRole==1)&&!isRecord" @click.stop.prevent="copyRightHandle()" size="small" class="copy-right">点击备案</w-button>
              </div>
            </w-col>
            <w-col class="status" :class="[isRecord?'record-status':'', !isRecord || prjStatus.description ? 'has-desc' : '']">
                <span class="item cursor-pointer" :class="{'link-color':!(activeTab-0>10)}" @click="setTab()">
                  项目文件
                </span>
                <span class="item cursor-pointer" :class="{'link-color': activeTab === '11'}" @click="setTab('11')">
                  项目成员
                </span>
                <div class="prj-members-tips" v-show= "showMemTips && !isRecord">
                  <span class="triangle"></span>
                  <span class="rectangle">
                    <i class="r2-icon-Click"></i>
                    <span>点击这里管理项目成员权限</span>
                    <i class="r2-icon-nav_close prj-tips-i" @click.stop = "closeTips"></i>
                  </span>
                </div>
                <span class="item cursor-pointer":class="{'link-color': activeTab === '12'}" @click="setTab('12')">
                  操作记录
                </span>
                <span v-if="!isRecord && prjStatus.createType !== 'upload'" class="item cursor-pointer":class="{'link-color': activeTab === '13'}" @click="setTab('13')">
                  回收站
                </span>
            </w-col>
          </w-row>
          <w-row type="flex" class="describtion" justify="space-between">
            <div key=1 v-if="showDiscription" class="text-align-justify" style="width: 50%;word-break: break-all;">
              {{explod?prjStatus.description.substring(0, len):prjStatus.description}}
              <span v-if="len" class="cursor-pointer hover-blue" @click="explodHandle">
              <i v-if="explod">...</i>
              <i v-else class='r2-icon-nav_expand_less'></i>
            </span>
            </div>
            <div key=2 v-else ref="text" @click="showDiscription=true" class="text-align-justify" style="width: 50%;word-break: break-all;">
              {{prjStatus.description}}
            </div>
          </w-row>
        </div>
        <!-- <div :class="['features', cloudApps.length ? '' : 'no-app']" v-if="!isRecord">
          <div class="item cursor-pointer cloud_menu">
            <template v-if="!cloudApps.length">
              <div class="cloud_content cloud_content_0">
                暂无项目云应用
              </div>
            </template>
            <div v-else :class="['cloud_content', 'cloud_content_' + (cloudApps.length > 4 ? 4 : cloudApps.length)]">
              <div class="cloud_content__inner flex flex-row align-center">
                <div class="item cursor-pointer" v-for="(cloudItem, idx) in cloudApps"
                     :title="cloudItem.name"
                     :key="'cloud-item-' + idx" @click="viewCloudApp(cloudItem)">
                  <div class="circle" :style="{backgroundImage: 'url(' + cloudItem.icon + ')'}">
                  </div>
                  <div class="txt ellipsis-1">{{cloudItem.name}}</div>
                </div>
              </div>
            </div>
            <div class="mask">
            </div>
            <div class="circle_menu">
              <i class="r2-icon-yyy"></i>
            </div>
            <div class="txt">项目云应用</div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="flex-1 flex flex-row">
      <div class="prj-status-container" v-if="!(activeTab-0>10)" style="width:150px; border-right: 1px solid rgba(33, 37, 48, 0.15);">
        <Progress :type="+prjStatus.prjType" :searchAll="searchAll" :activeTab="activeTab==1||activeTab==10?defaultTab:activeTab" :hasTxt="true" :data="prjStatus.prjStatus" @statusHandle="statusHandle"></Progress>
      </div>
      <div class="flex-1 project-body">
        <router-view></router-view>
      </div>
    </div>
    <w-dialog :show="copyRight.show" customClass="copy-right-dialog">
      <div v-if="copyRight.copyrightStep===1">
        <h4 class="copy-right-header">选择备案项目标签</h4>
        <div class="copy-right-body">
          <w-radio class="radio" v-model="copyRight.radio" label="0">未中标项目</w-radio>
          <w-radio class="radio" v-model="copyRight.radio" label="1">中标项目</w-radio>
          <w-radio class="radio" v-model="copyRight.radio" label="2">结算项目</w-radio>
          <w-radio class="radio" v-model="copyRight.radio" label="3">评估项目</w-radio>
          <p v-if="copyRight.check && !copyRight.radio" style="color: red;">请选择标签！</p>
        </div>
      </div>
      <p v-else class="copy-right-content">
        <i class="w-icon-qiangtixing color-warn warn-icon"></i>
        项目备案后，所有文件归档保存，将无法修改项目内文件，是否继续？
      </p>
      <div class="font-right">
        <w-button key="1" v-if="copyRight.copyrightStep===1" type="primary" @click="copyRightHandle(2)">完成备案</w-button>
        <w-button key="2" v-else type="primary" @click="copyRightHandle(1)">确认备案</w-button>
        <w-button type="minor" @click="copyRight.show=false">取消</w-button>
      </div>
    </w-dialog>


  </div>
</template>
<style lang="less">
body{
  .copy-right-dialog{
    width: 400px;
  }
}
</style>
<style lang="less" type="text/less" scoped>
.copy-right-header{
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
  color:rgba(33,37,48,1);
}
.copy-right-body{
  height: 90px;
  .radio{
    line-height: 30px;
    &:nth-child(3){
      margin-right: 0px;
    }
  }
}
.copy-right-content{
  margin-left: 50px;
  margin-bottom: 35px;
  position: relative;
  line-height:22px;
  .warn-icon{
    font-size: 30px;
    position: absolute;
    left: -48px;
    top: 7px;
  }
}
.project-detail {
  .project-head{
    border-bottom: 1px solid rgba(33, 37, 48, 0.15);
  }
  .project-body{
    margin-top: 24px;
  }
  .mg-righ-12 {
    margin-right: 12px;
  }
  .tab-content {
    margin-left: 24px;
    margin-right: 24px;
  }
  .tab-btn {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-weight: 400;
    color: rgba(33, 37, 48, 0.8);
    line-height: 20px;
    display: inline-block;
    margin: 0 12px;
  }
  .link-color {
    color: #1890ff!important;
  }
  .go-list {
    width: 28px;
    color:rgba(33, 37, 48, 0.55);
    padding-top: 3px;
    .r2-icon-hardware_keyboard_backspace_outlined{
      font-size: 24px;
    }
  }
  .copy-right {
    position: relative;
    left: 14px;
  }
  .name {
    font-size: 20px;
    font-weight: 500;
    color: rgba(33, 37, 48, 1);
    line-height: 1;
    span{
      line-height: 32px;
      float: left;
    }
  }
  .content-msg {
    flex: 1;
    .pricing-collaboration {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin: 9px 0 9px 8px;
      float: left;
      background-image: url("~@/assets/images/project/pricing-collaboration.png");
    }
  }
  .describtion {
    font-size: 14px;
    font-weight: 400;
    color: rgba(33, 37, 48, 0.55);
  }
  .status {
    display: flex;
    width: 400px;
    height: 43px;
    justify-content: space-between;
    align-items: center;
    &.record-status{
      width: 260px;
    }
    &.has-desc {
      .item {
        margin-top: 15px;
      }
    }
    .item {
      flex: 1;
      text-align: center;
      border-right: 1px solid rgba(33, 37, 48, 0.15);
      height: 14px;
      line-height: 16px;
      padding: 0 10px;
      font-size: 16px;
      font-weight: 500;
      &:last-child{
        border: 0;
      }
    }
  }
  .margin {
    margin: 18px 15px 15px 24px;
  }
  .features {
    height: 64px;
    width: auto;
    margin-left: 24px;
    .circle{
      width: 40px;
      height: 40px;
      /*background: linear-gradient(*/
        /*360deg,*/
        /*rgba(71, 157, 255, 1) 0%,*/
        /*rgba(0, 104, 255, 1) 100%*/
      /*);*/
      background-size: cover!important;
      /*border-radius: 50%;*/
      /*color: #fff;*/
      line-height: 40px;
      text-align: center;
    }
    .cloud_menu{
      position: relative;
      left: 0;
      top: 0;
      .cloud_content{
        opacity: 0;
        box-shadow:0px 2px 8px 0px rgba(33,37,48,0.2);
        transform: translateX(0);
        /*width: 125px;*/
        max-width: 372px;
        padding: 0 24px;
        height: 90px;
        background: #fff;
        position: absolute;
        top: -16px;
        /*left: -299px;*/
        left: 0;
        transition: all cubic-bezier(0.47, 0, 0.745, 0.715) 0.5s;
        &::before{
          content: '';
          border-left: 12px solid #fff;
          border-right: 12px solid transparent;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          position: absolute;
          right: -20px;
          top: 23px;
          z-index: 1;
        }
        &::after{
          content: '';
          border-left: 12px solid #eaeaea;
          border-right: 12px solid transparent;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          position: absolute;
          right: -23px;
          top: 23px;
        }
        &.cloud_content_0{
          padding: 20px 24px;
          width: 112px;
          height: 24px;
          line-height: 24px;
          top: -10px;
        }
        &.cloud_content_1{
          .cloud_content__inner{
            width: 60px;
          }
        }
        &.cloud_content_2{
          .cloud_content__inner{
            width: 148px;
          }
        }
        &.cloud_content_3{
          .cloud_content__inner{
            width: 236px;
          }
        }
        &.cloud_content_4{
          .cloud_content__inner{
            width: 324px;
          }
        }
        &__inner{
          height: 90px;
          overflow-x: auto;
          &>.item{
            width: 60px;
            .txt{
              width: 60px;
              text-align: center;
            }
          }
          &>div{
            margin-right: 28px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
      }
      &:hover{
        .cloud_content.cloud_content_0{
          opacity: 1;
          display: flex;
          transform: translateX(-175px);
          transition: all ease-out 0.5s;
        }
        .cloud_content.cloud_content_1{
          opacity: 1;
          display: flex;
          transform: translateX(-123px);
          transition: all ease-out 0.5s;
        }
        .cloud_content.cloud_content_2{
          opacity: 1;
          transform: translateX(-211px);
          transition: all ease-out 0.8s;
        }
        .cloud_content.cloud_content_3{
          opacity: 1;
          transform: translateX(-299px);
          transition: all ease-out 1.1s;
        }
        .cloud_content.cloud_content_4{
          opacity: 1;
          transform: translateX(-387px);
          transition: all ease-out 1.1s;
        }
      }
    }
    &.no-app{
      .item{
        .circle_menu .r2-icon-yyy, .txt{
          color: rgba(33, 37, 48, 0.35);
        }
      }
    }
    .item {
      float: right;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .mask{
        position: absolute;
        background: #fff;
        top: -22px;
        left: -5px;
        width: 100px;
        height: 100px;
      }
      .circle_menu {
        position: relative;
        z-index: 10;
        width: 42px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        .r2-icon-yyy{
          font-size: 42px;
          color: rgba(0, 104, 255, 1);
        }
      }
      .txt {
        position: relative;
        z-index: 10;
        font-size: 12px;
        font-weight: 400;
        color: rgba(33, 37, 48, 0.75);
        line-height: 20px;
        margin-top: 7px;
      }
    }
  }
}
.prj-members-tips{
  cursor: pointer;
  position: relative;
  right: 208px;
  top: 120px;
  z-index: 999;
  animation: dialog-fade-in .3s;
  .rectangle{
    position: absolute;
    z-index: 10;
    text-align: left;
    bottom: 0;
    left: 0;
    width: 300px;
    height: 74px;
    line-height: 74px;
    background: rgba(32,121,250,1);
    box-shadow: 0px 2px 8px 0px rgba(33,37,48,0.15);
    border-radius: 4px;
    span{
      margin-left:16px;
      font-size:16px;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    &>i{
      margin-left: 20px;
      font-size: 32px;
      color:rgba(255,255,255,1);
    }
    .prj-tips-i{
      position: absolute;
      font-size: 20px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      right: 8px;
      top: 8px;
      color:rgba(255,255,255,0.55);
    }
  }
  .triangle{
    position: absolute;
    bottom: 74px;
    left: 146px;
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgba(32,121,250,1);
    border-left: 10px solid transparent;
  }
}
</style>
<script>
import { getCookie } from '@/assets/utils/CommonUtil'
import r2Project from '@/assets/service/r2Project'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { zjycloud } from '@/assets/js/config'
import { isIE } from '@/assets/utils'
import Progress from '../component/PrjStatus'
import api from 'service'
import Bus from '@/assets/utils/bus'
let role
switch (+getCookie('role')) {
  case 1:
    role = '管理员'
    break
  case 2:
    role = '总负责人'
    break
  case 3:
    role = '数据库负责人'
    break
  case 4:
    role = '普通员工'
    break
  default:
    role = '管理员'
    break
}
export default {
  name: 'ProjectDetail',
  data () {
    return {

      cloudApps: [], // 项目云应用列表
      prjId: this.$route.params.id,
      prjStatus: {
        prjStatus: {},
        description: ''
      },
      isIE: isIE(),
      searchAll: false,
      activeTab: 1,
      defaultTab: '',
      showDiscription: false,
      len: false,
      explod: false,
      isAdmin: false,
      copyRight: {
        show: false,
        copyrightStep: 0,
        radio: '',
        check: false
      },
      isRecord: /\/database\/data\/record\//.test(this.$route.path),
      showMemTips: false // 是否展示引导提示
    }
  },
  components: {
    Progress
  },
  created () {
    this.isAdmin = this.hasPermissonList('zjy_module_project_baxm_manage')
    this.init()
  },
  watch: {
    'prjStatus.description': function () {
      let that = this
      this.$nextTick(() => {
        let text = this.$refs.text; let str = text.innerHTML
        this.len = overflowhidden(text, 2, str, that)
        if (this.len){
          this.len = this.len - 5
          this.showDiscription = true
          this.explod = true
        }
      })
    },
    activeTab: function (data) {
      if (+data === 1 || +data === 10) {
        this.searchAll = true
      } else {
        this.searchAll = false
      }
    },
    prjRole: function (val) {
      if (role !== '总负责人') {
        if (+val === 1) {
          role = '项目管理者'
        } else {
          role = '项目编辑者'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['path', 'prjRole'])
  },
  mounted () {

    // this.initTips()
    Bus.$on('setTabActive', (activeTab) => {
      this.statusHandle(activeTab)

    })
  },
  methods: {
    ...mapActions({fetchRole: 'project/fetchRole'}),
    ...mapMutations({
      setTabActive: 'project/SET_ACTIVE',
      setStatus: 'project/SET_STATUS',
      setCategory: 'project/SET_CATEGORY',
      setName: 'project/SET_NAME',
      setType: 'project/SET_TYPE',
      setRole: 'project/SET_ROLE'
    }),
    // 1. 初始化
    init () {
      // 获取项目信息、云应用、等等
      this.getPrjDetail()
      // 获取角色
      this.fetchRole({ id: this.$route.params.id }).then(() => {})
    },
    // 1.2 设置activeTab
    setActiveTab (prjStatus) {
      if (this.$route.path.indexOf('/files/') > 0) {
        let num = Object.values(prjStatus).lastIndexOf(1)
        num = num === -1 ? 0 : num
        // 2021.3.20 ker 工作台跳转，路由中带有项目阶段时，且阶段类型合法时，使用参数中阶段 -- start
        const {originStage = ''} = this.$route.query
        if (originStage && Object.keys(prjStatus).includes(originStage)) {
          this.activeTab = originStage
        } else {
          this.activeTab = Object.keys(prjStatus)[num]
        }
        // 2021.3.20 ker 工作台跳转，路由中带有项目阶段时，且阶段类型合法时，使用参数中阶段 -- end
        // this.activeTab = Object.keys(prjStatus)[num]
        this.defaultTab = this.activeTab
        this.setTabActive(this.activeTab)
      } else if (this.$route.path.indexOf('/members') > 0) {
        this.activeTab = '11'
      } else if (this.$route.path.indexOf('/logs') > 0) {
        this.activeTab = '12'
      } else if (this.$route.path.indexOf('/recycle') > 0) {
        this.activeTab = '13'
      }
    },
    // 1.3 获取项目云应用列表
    getCloudApps (stage) {
      if (!this.isRecord) {
        if (stage === '全部文件') {
          stage = ''
        }
        const params = {
          language: 'cn',
          gray: document.domain,
          stage
        }
        console.log('----------')
        console.log(stage)
        this.cloudApps = []
        api.common.getProjectsCloudApps(params).then((res) => {
          if (+res.code === 200 && res.data) {
            this.cloudApps = res.data || []
          }
        })
      }
    },
    // 2.1 回收站、文件、操作记录、成员切换
    setTab (data) {
      let type = 'prj'
      if (this.isRecord) {
        type = 'record'
      }
      if (!data){
        this.sentLog(100112016)
        data = this.defaultTab
      }
      this.activeTab = data
      switch (data) {
        case '10':
          this.setTabActive(data)
          this.$router.push({ name: `${type}Files` })
          break
        case '11':
          this.sentLog(100112018)
          this.$router.push({ name: `${type}Members` })
          break
        case '12':
          this.sentLog(100112019)
          this.$router.push({ name: `${type}Logs` })
          break
        case '13':
          this.sentLog(100112020)
          this.$router.push({ name: `${type}Recycle` })
          break
        case '14':
          this.sentLog(100112060)
          this.$router.push({ name: `${type}Info` })
          break
        default:
          this.callback(data)
          break
      }
    },
    // 2.2 文件跳转
    callback (key) {
      let type = 'prj'
      if (this.isRecord) {
        type = 'record'
      }
      this.setTabActive(key)
      const query = this.$route.query
      this.$router.push({name: `${type}Files`, params: {status: key}, query})
    },
    // 3.1 获取项目信息
    getPrjDetail () {
      let params = { id: this.$route.params.id }
      r2Project
        .getPrjDetail(params)
        .then(res => {
          if (+res.code === 200) {
            if (!res.data.prjStatus){
              res.data.prjStatus = {
                '全部文件': 2
              }
            }
            this.setActiveTab(res.data.prjStatus)
            let num = Object.values(res.data.prjStatus).lastIndexOf(1)
            num = num === -1 ? 0 : num
            this.defaultTab = Object.keys(res.data.prjStatus)[num]
            this.getCloudApps(this.defaultTab)
            // res.data.createType = 'upload'
            this.prjStatus = res.data
            this.setType(+this.prjStatus.prjType)
            this.setRole(this.prjStatus.role)
            this.setName(this.prjStatus.prjName)
            this.setStatus(this.prjStatus.prjStatus)
            console.log(`this.prjStatus.prjCategory:${this.prjStatus.prjCategory}`)
            this.setCategory(this.prjStatus.prjCategory)
            // if (role !== '总负责人') {
            //   if (+this.prjStatus.role === 1) {
            //     role = '项目管理者'
            //   } else {
            //     role = '项目编辑者'
            //   }
            // }
          } else {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取项目信息失败！'
            })
          }
        })
        .catch(() => {
          this.$message.error('获取项目信息失败！')
        })
    },
    // 3.2 更改进度
    statusHandle (index) {
      this.activeTab = index
      this.defaultTab = index
      this.callback(index)
      this.getCloudApps(index)
      switch (index) {
        case '评估文件':
          this.sentLog(100112021)
          break
        case '招投标文件':
          this.sentLog(100112022)
          break
        case '合同文件':
          this.sentLog(100112023)
          break
        case '施工资料':
          this.sentLog(100112024)
          break
        case '结算文件':
          this.sentLog(100112025)
          break
        default:
          break
      }
    },
    // 4.1 多工程报表
    // goReport (item) {
    //   let wsId = getCookie('projectWorkspaceIdValue')
    //   let projectId = this.$route.params.id
    //   this.sentLog(100112017)
    //   window.open(
    //     `/multicloudreport/wsId/${wsId}/projectId/${projectId}`,
    //     '_blank'
    //   )
    // },
    // 查看某个项目云应用
    viewCloudApp (item) {
      const projectId = this.$route.params.id
      switch (item.name) {
        case '多工程报表':
          this.sentLog(100112017)
          break
        default:
      }
      this.openLinkNewTab(Object.assign(item, {projectId}))
    },
    enterClick () {
      console.log('ssss')
      this.$children[2].searchHandle()
    },
    // 4.2 备案
    copyRightHandle (data) {
      if (!data) {
        this.copyRight.copyrightStep = 0
        this.copyRight.show = true
        this.copyRight.check = false
        this.sentLog(100112026)
      } else if (data === 1) {
        this.copyRight.copyrightStep = 1
      } else {
        if (!this.copyRight.radio) {
          this.copyRight.check = true
          return
        }
        let params = {
          projectTag: this.copyRight.radio,
          url: zjycloud + '/#/database/data/record/'
        }
        r2Project.putCopyRight(this.$route.params.id, params).then((res) => {
          if (res.code === 200) {
            this.$router.replace({path: this.path})
          } else {
            this.copyRight.copyrightStep = 0
            this.$message({
              type: 'error',
              message: res.message ? res.message : '备案失败！'
            })
          }
        }).catch(() => {
          this.copyRight.copyrightStep = 0
          this.$message({
            type: 'error',
            message: res.message ? res.message : '备案失败！'
          })
        })
      }
    },
    closeTips (){
      this.showMemTips = false
      api.common.setTips('PRJMEMTIPS').then(res => {
        if (res.code === 200) {
          console.log('PRJMEMTIPS_close')
        }
      })
    },
    initTips (){
      api.common.getTips().then(res => {
        if (res.code === 200) {
          let data = res.data || {}
          this.showMemTips = !data.PRJMEMTIPS
        }
        let _self = this
        // 十秒后自动关闭提示
        setTimeout(function (){
          _self.showMemTips = false
          api.common.setTips('PRJMEMTIPS').then(res => {
            if (res.code === 200) {
              console.log('PRJMEMTIPS_close')
            }
          })
        }, 10000)
      })
    },
    explodHandle (){
      this.explod = !this.explod
    }

  }
}
var overflowhidden = function (el, rows, str, that){
  var text = el
  var at = rows * parseInt(24)
  var tempstr = str
  text.innerHTML = tempstr
  var len = tempstr.length
  var i = 0
  if (text.offsetHeight <= at){
    return false
  } else {
    var temp = ''
    text.innerHTML = temp
    while (text.offsetHeight <= at){
      temp = tempstr.substring(0, i + 1)
      i++
      text.innerHTML = temp
    }
    var slen = temp.length
    tempstr = temp.substring(0, slen - 1)
    len = tempstr.length
    return len - 14
  }
}
</script>
